import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import $ from 'jquery'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'
import {
  getTrainingType,
  formatStartAndEndDates,
  getTimezoneShortName,
  getBuildingTimezoneFromEvent,
  getDayNameByNumber,
  getTimeString,
} from '../../helpers/helpers'

const CalendarBlockedTimeslotPopup = ({ open, event, target, onClose }) => {
  const { t } = useTranslation(['calendar'])
  const [arrowPosition, setArrowPosition] = useState('')

  const calculatePopupPosition = (target) => {
    const calendarView = $('.rbc-calendar > div:last-child')
    const popup = $('.ctp-event-popup')
    const arrow = $('.ctp-event-popup__arrow')
    const sidebarWidth = $('.ctp-sidebar').outerWidth() || 0
    const toolbarHeight = $('.ctp-toolbar').outerHeight() || 0
    const calculateXposition = () => {
      popup.css({
        left: 'auto',
      })
      if (
        calendarView.width() - (target.offset().left + target.width() - sidebarWidth) >
        popup.width()
      ) {
        popup.css({
          left: target.offset().left + target.width() - sidebarWidth,
        })
        setArrowPosition('left')
      } else {
        popup.css({
          left: target.offset().left - popup.width() - sidebarWidth,
        })
        setArrowPosition('right')
      }
    }
    const calculateYposition = () => {
      popup.css({
        top: 'auto',
        bottom: 'auto',
      })
      arrow.css({
        top: 'auto',
        bottom: 'auto',
      })
      const offsetTop = -17
      const calculatedTopPosition = target.offset().top - calendarView.offset().top - offsetTop
      if (calendarView.height() - popup.height() > calculatedTopPosition) {
        popup.css({
          top: calculatedTopPosition,
        })
        arrow.css({
          top: 35,
        })
      } else {
        popup.css({
          top: calendarView.height() - popup.height() + toolbarHeight + 1,
        })
        arrow.css({
          bottom:
            calendarView.height() +
            calendarView.offset().top -
            target.offset().top -
            target.height() +
            3,
        })
      }
    }

    calculateXposition()
    calculateYposition()
  }

  const setEventActiveClass = (target) => {
    target.addClass('ctp-event--active')
  }

  const removeEventActiveClass = () => {
    $('.ctp-event').removeClass('ctp-event--active')
  }

  const getReservationName = (name) => {
    if (name === 'unavailableSlot') {
      return t('calendar:reservationTypes.unavailableSlot')
    }
    return t('calendar:reservationTypes.phantomBooking')
  }

  const trainingType = getTrainingType(event)
  const timezone = getBuildingTimezoneFromEvent(event)
  let eventColor = '#88ABE6'
  let eventIcon = 'calendarReservation'
  let eventIconViewBox = '0 0 9 9'
  let eventType = event.name

  let [start, end] = formatStartAndEndDates(trainingType, event, timezone)

  useEffect(() => {
    removeEventActiveClass()
    if (open) {
      calculatePopupPosition(target)
      setEventActiveClass(target)
    }
  })

  return (
    <div
      className={`ctp-event-popup ${open ? 'ctp-event-popup--active' : ''} ${
        arrowPosition === 'right' ? 'ctp-event-popup--pos-right' : ''
      }`}
    >
      <span className="ctp-event-popup__arrow" />
      <header
        className="ctp-event-popup__header"
        style={{
          backgroundColor: eventColor,
        }}
      >
        <div className="ctp-event-popup__header-inner">
          <div className="ctp-event-popup__icon">
            <Icon icon={eventIcon} viewBox={eventIconViewBox} />
          </div>
          <div className="ctp-event-popup__title">
            <h2>
              {getReservationName(event.reservationType)} {event.title}
            </h2>
            {event.reservationType === 'unavailableSlot' && event.isWeeklySlot ? (
              <h3>
                {t('calendar:blockedTimeslotPopup.recurringWeekly', {
                  day: getDayNameByNumber(moment(event.start).day()),
                })}
              </h3>
            ) : null}
          </div>
        </div>
        <div className="ctp-event-popup__close">
          <button
            onClick={(e) => {
              e.preventDefault()
              onClose()
            }}
          >
            <Icon icon="cross" />
          </button>
        </div>
      </header>
      <div className="ctp-event-popup__inner">
        {event.reservationType === 'unavailableSlot' && timezone ? (
          <time className="ctp-event-popup__time">
            {start} - {end}
            {timezone ? ` ${getTimezoneShortName(timezone)}` : null}
          </time>
        ) : null}
        <div className="ctp-event-popup__detail">
          <span className="ctp-event-popup__detail-title">
            {t('calendar:blockedTimeslotPopup.amenity')}
          </span>
          <div className="ctp-event-popup__detail-info">
            <span> {eventType} </span>
          </div>
        </div>
        {event.reservationType === 'unavailableSlot' && (
          <div className="ctp-event-popup__detail">
            <span className="ctp-event-popup__detail-title">
              {t('calendar:blockedTimeslotPopup.duration')}{' '}
            </span>
            <div className="ctp-event-popup__detail-info">
              <span> {getTimeString(event.endTime - event.startTime)} </span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

CalendarBlockedTimeslotPopup.propTypes = {
  event: PropTypes.object.isRequired,
  onEditEvent: PropTypes.func,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  target: PropTypes.object,
}

export default CalendarBlockedTimeslotPopup
